// Product Styles
import React from 'react';
import PropTypes from 'prop-types';
import Filter from '../filter/Filter';
import ProductStyleList from './ProductStyleList';

const ProductStyles = ({
  filterToggle,
  filterToggleClick,
  filters,
  selectedFilters,
  productStyles,
  buttonClick,
  closeAllDropdowns,
  filterClick,
  removeFilter,
  clearFilters,
}) => (
  <div className="container product-category-container">
    <section className="filter product-category-filter">
      <div className="filter-heading fw-bold fs-lg">Filter Products</div>
      <div className={`filter-toggle${filterToggle ? ' toggled' : ''}`}>
        <Filter
          filters={filters}
          selectedFilters={selectedFilters}
          buttonClick={buttonClick}
          closeAllDropdowns={closeAllDropdowns}
          filterClick={filterClick}
          removeFilter={removeFilter}
          clearFilters={clearFilters}
        />
        <button className={`filter-toggle-button${filterToggle ? ' toggled-button-close' : ''}`} type="button" onClick={() => filterToggleClick()}>Apply</button>
      </div>
      <button className={`filter-toggle-button${filterToggle ? ' toggled-button' : ''}`} type="button" onClick={() => filterToggleClick()}>Filter Products</button>
    </section>
    <section className="product-links productstyle-links">
      <ProductStyleList productStyles={productStyles} />
    </section>
  </div>
);

ProductStyles.propTypes = {
  filterToggle: PropTypes.bool,
  filterToggleClick: PropTypes.func.isRequired,
  buttonClick: PropTypes.func.isRequired,
  closeAllDropdowns: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  filters: PropTypes.shape(PropTypes.object),
  selectedFilters: PropTypes.shape({
    productLineFilter: PropTypes.arrayOf(PropTypes.string),
    colorRangeFilter: PropTypes.arrayOf(PropTypes.string),
    opacityFilter: PropTypes.arrayOf(PropTypes.string),
    priceFilter: PropTypes.arrayOf(PropTypes.string),
    energyEfficiencyFilter: PropTypes.arrayOf(PropTypes.string),
    choiceFilter: PropTypes.arrayOf(PropTypes.string),
  }),
  productStyles: PropTypes.arrayOf(PropTypes.object),
};

export default ProductStyles;
